import { useContext, useMemo } from 'react';
import { useMatches } from 'react-router-dom';
import { ChatContainer } from '@trinity/chat-components/components/BrandInsights/Chat.Container.js';
import {
  BrandInsightsModalContext,
  ChatViewType,
  ChatViewTypeContext,
} from '@trinity/chat-components/components/BrandInsights/context.js';
import {
  LinkHashContainer,
  LinkStateContainer,
  useBrandInsightsHash,
} from '@trinity/chat-components/components/BrandInsights/Link.Container.js';
import { ChatModal } from '@trinity/chat-components/components/Chat.Modal/index.js';
import { ChatStateContainer } from '@trinity/chat-components/components/Chat.State/Chat.State.js';
import { ChatWidget } from '@trinity/chat-components/components/Chat.Widget/index.js';

type Props = unknown;

// Routes that already embed their own full DigitalTwinChat interface — the floating widget
// would just be a redundant second chat entry point on top of it.
const HIDDEN_ROUTE_PATTERNS = [
  /^\/projects\/[^/]+\/hcp-digital-twins(?:\/|$)/,
  /^\/projects\/[^/]+\/segments\/[^/]+\/dashboard(?:\/|$)/,
  /^\/projects\/[^/]+\/patient-journey\/[^/]+\/manage$/,
];

export const ChatWidgetContainer = (props: Props) => {
  const hashValue = useBrandInsightsHash();
  const matches = useMatches();

  const [open, handleToggle] = useContext(BrandInsightsModalContext);

  const enabled = useMemo(() => {
    if (open) return false;

    if (matches.some((x) => HIDDEN_ROUTE_PATTERNS.some((pattern) => pattern.test(x.pathname)))) {
      return false;
    }

    return matches.some((x) => {
      if (!x.pathname.length) return false;
      const pathSegment = x.pathname.match(/^\/[^/]+/)?.[0];
      return pathSegment === '/workspaces' || pathSegment === '/projects' || pathSegment === '/project';
    });
  }, [matches, open]);

  return (
    <>
      {enabled && <ChatWidget onClick={handleToggle} />}
      <ChatStateContainer>
        <LinkStateContainer initialChatIdentifier={hashValue}>
          <LinkHashContainer>
            {open && (
              <ChatViewTypeContext.Provider value={ChatViewType.Modal}>
                <ChatContainer>
                  <ChatModal onClose={handleToggle} open={open} />
                </ChatContainer>
              </ChatViewTypeContext.Provider>
            )}
          </LinkHashContainer>
        </LinkStateContainer>
      </ChatStateContainer>
    </>
  );
};
